import React from "react";
import "./GlobalVisa.css";

const GlobalVisa = () => {
    return (
        <div className='globalvisa' id='visa'>
            <h6>Global Visa Services</h6>
            <div className="global-visa-content">
                <div className="global-content">
                    <h5>Pack Your Bags </h5>
                    <h5>Without Paperwork Stress</h5>
                    <p>We handle all international visa documentation and provide dedicated support services to make your journey hassle-free. And we specialize in Schengen visa</p>
                </div>
            </div>
        </div>
    )
}

export default GlobalVisa;
